import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { _n, sprintf } from '@wordpress/i18n';
import { Flex, FlexItem } from '@wordpress/components';
import { dragHandle } from '@wordpress/icons';
/**
 * Internal dependencies
 */

import BlockIcon from '../block-icon';
export default function BlockDraggableChip(_ref) {
  let {
    count,
    icon
  } = _ref;
  return createElement("div", {
    className: "block-editor-block-draggable-chip-wrapper"
  }, createElement("div", {
    className: "block-editor-block-draggable-chip"
  }, createElement(Flex, {
    justify: "center",
    className: "block-editor-block-draggable-chip__content"
  }, createElement(FlexItem, null, icon ? createElement(BlockIcon, {
    icon: icon
  }) : sprintf(
  /* translators: %d: Number of blocks. */
  _n('%d block', '%d blocks', count), count)), createElement(FlexItem, null, createElement(BlockIcon, {
    icon: dragHandle
  })))));
}
//# sourceMappingURL=draggable-chip.js.map